import { render, staticRenderFns } from "./invoiceCollapse.vue?vue&type=template&id=1fbc7006&"
import script from "./invoiceCollapse.vue?vue&type=script&lang=js&"
export * from "./invoiceCollapse.vue?vue&type=script&lang=js&"
import style0 from "./invoiceCollapse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports